module.exports = __webpack_public_path__ + "static/media/Paper Cutout-100.817ec480.webp";